(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["chrome-browse-products"] && !Shopify.designMode) return;
  try {
    
function chromeProductMatches(p,f,kind){const fields=kind==='tires'?{brand:2,size:5,diameter:6,width:7,ratio:8}:{brand:2,category:5};for(const [key,index] of Object.entries(fields))if(f[key]&&p[index]!==f[key])return false;const text=(p[0]+' '+p[1]+' '+p[2]+' '+p[5]).toLowerCase();return String(f.search||'').trim().toLowerCase().split(/\s+/).filter(Boolean).every(w=>text.includes(w))}
if(!customElements.get('chrome-product-browser'))customElements.define('chrome-product-browser',class extends HTMLElement{
connectedCallback(){if(this.started)return;this.started=true;this.s=JSON.parse(this.querySelector('.ccp-strings').textContent);this.form=this.querySelector('form');this.grid=this.querySelector('.ccp-grid');this.count=this.querySelector('.ccp-count');this.more=this.querySelector('.ccp-more');this.sort=this.querySelector('.ccp-sort');this.money=new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'});this.limit=24;this.form.addEventListener('submit',e=>e.preventDefault());this.form.addEventListener('input',()=>{clearTimeout(this.timer);this.timer=setTimeout(()=>this.filter(),120)});this.form.addEventListener('reset',()=>setTimeout(()=>this.filter(),0));this.sort.addEventListener('change',()=>this.filter());this.more.addEventListener('click',()=>{this.limit+=24;this.render()});Promise.all(this.dataset.catalog.split(',').map(u=>fetch(u).then(r=>{if(!r.ok)throw Error();return r.json()}))).then(parts=>{this.products=parts.flat();this.populate();this.filter()}).catch(()=>{this.count.textContent=this.s.error})}
populate(){}
updateOptions(f){
 const fields=this.dataset.kind==='tires'?{brand:2,size:5,diameter:6,width:7,ratio:8}:{brand:2,category:5};
 for(const [key,index] of Object.entries(fields)){
   const other={...f,[key]:''};
   const values=new Set(this.products.filter(p=>chromeProductMatches(p,other,this.dataset.kind)).map(p=>p[index]).filter(Boolean));
   if(f[key])values.add(f[key]);
   const select=this.form.elements[key];const blank=select.options[0].cloneNode(true);select.replaceChildren(blank);
   [...values].sort((a,b)=>a.localeCompare(b,undefined,{numeric:true})).forEach(value=>{const option=document.createElement('option');option.value=value;option.textContent=key==='category'?this.s[value]:value;select.append(option)});
   select.value=f[key]||'';select.disabled=false;
 }
}
filter(){if(!this.products)return;this.limit=24;const f=Object.fromEntries(new FormData(this.form));this.updateOptions(f);this.matches=this.products.filter(p=>chromeProductMatches(p,f,this.dataset.kind));const sort=this.sort.value;this.matches.sort((a,b)=>{if(sort==='name')return a[1].localeCompare(b[1]);if(a[3]===null)return b[3]===null?0:1;if(b[3]===null)return -1;return sort==='low'?a[3]-b[3]:b[3]-a[3]});this.render()}
quote(p){const u=new URL(this.dataset.quote,location.origin);u.searchParams.set('service',this.dataset.kind);u.searchParams.set('product',p[1]);u.searchParams.set('sku',p[0]);const preview=new URLSearchParams(location.search).get('preview_theme_id');if(preview)u.searchParams.set('preview_theme_id',preview);return u.pathname+u.search}
node(tag,cls,text){const n=document.createElement(tag);if(cls)n.className=cls;if(text!==undefined)n.textContent=text;return n}
render(){this.grid.replaceChildren();this.count.textContent=this.matches.length.toLocaleString()+' '+this.s.results;this.more.hidden=this.matches.length<=this.limit;if(!this.matches.length){this.grid.append(this.node('p','ccp-empty',this.s.empty));return}for(const p of this.matches.slice(0,this.limit)){const card=this.node('article','ccp-card');const media=this.node('div','ccp-media');const fallback=this.node('span','',this.s.photo);media.append(fallback);if(p[4]&&/^https?:\/\//i.test(p[4])){const img=this.node('img');img.src=p[4];img.alt=p[1];img.loading='lazy';img.width=400;img.height=400;fallback.hidden=true;img.addEventListener('error',()=>{img.remove();fallback.hidden=false},{once:true});media.append(img)}card.append(media,this.node('p','ccp-brand',p[2]),this.node('h2','',p[1]),this.node('p','ccp-spec',this.s.sku+': '+p[0]));const price=this.node('p','ccp-price',p[3]===null?this.s.unknown_price:this.money.format(p[3]));if(p[3]!==null)price.append(this.node('small','',this.s.price));card.append(price);const order=this.node('chrome-catalog-order');order.dataset.kind=this.dataset.kind;order.dataset.title=p[1];order.dataset.brand=p[2];order.dataset.skus=JSON.stringify([p[0]]);card.append(order);this.grid.append(card)}}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chrome-browse-wheels"] && !Shopify.designMode) return;
  try {
    
function chromeWheelDimensions(value){
  const match=String(value).trim().match(/^(\d+(?:\.\d+)?)\s*[xX×]\s*(\d+(?:\.\d+)?)$/);
  return match?[Number(match[1]),Number(match[2])]:null;
}
function chromeBasicFitmentMatch(v,vehicle){
  if(!vehicle)return true;
  if(!vehicle.eligible)return false;
  const wanted=vehicle.pattern.match(/^(\d+)x(\d+(?:\.\d+)?)$/i);
  if(!wanted||!Number.isFinite(vehicle.bore))return false;
  const bolts=[...String(v[2]).matchAll(/(\d+)\s*[xX]\s*(\d+(?:\.\d+)?)/g)];
  const boltMatch=bolts.some(m=>{const diameter=Number(m[2]);const mm=diameter<30?diameter*25.4:diameter;return Number(m[1])===Number(wanted[1])&&Math.abs(mm-Number(wanted[2]))<0.02});
  const boreText=String(v[5]).trim();
  if(!/^\d+(?:\.\d+)?$/.test(boreText))return false;
  return boltMatch&&Number(boreText)>=vehicle.bore;
}
if(!customElements.get('chrome-vehicle-request'))customElements.define('chrome-vehicle-request',class extends HTMLElement{
connectedCallback(){if(this.started)return;this.started=true;this.form=this.querySelector('form');this.s=JSON.parse(this.querySelector('.cvr-strings').textContent);this.status=this.querySelector('.cvr-status');this.selected=null;const p=new URLSearchParams(location.search);const preview=p.get('preview_theme_id');if(preview){const input=document.createElement('input');input.type='hidden';input.name='preview_theme_id';input.value=preview;this.form.append(input)}this.form.elements.year.addEventListener('change',()=>this.changeYear());this.form.elements.make.addEventListener('change',()=>this.changeMake());this.form.elements.model.addEventListener('change',()=>this.selectModel());this.querySelector('.cvr-clear').addEventListener('click',()=>{this.form.elements.year.value='';this.changeYear()});Promise.all(this.dataset.index.split(',').map(url=>fetch(url).then(r=>{if(!r.ok)throw Error();return r.json()}))).then(parts=>{this.rows=parts.flat();const years=new Set();this.rows.forEach(r=>{for(let y=r[0];y<=r[1];y++)years.add(String(y))});this.options('year',[...years].sort((a,b)=>b-a));this.status.textContent=this.s.idle;if(p.has('year')){this.form.elements.year.value=p.get('year');this.changeYear();if(p.has('make')){this.form.elements.make.value=p.get('make');this.changeMake();if(p.has('model')){this.form.elements.model.value=p.get('model');this.selectModel()}}}}).catch(()=>{this.status.textContent=this.s.error})}
options(key,values){const select=this.form.elements[key];select.replaceChildren();const blank=document.createElement('option');blank.value='';blank.textContent=this.s['choose_'+key];select.append(blank);values.forEach(v=>{const option=document.createElement('option');option.value=v;option.textContent=v;select.append(option)});select.disabled=!values.length}
changeYear(){const y=Number(this.form.elements.year.value);this.byYear=this.rows.filter(r=>r[0]<=y&&r[1]>=y);this.options('make',[...new Set(this.byYear.map(r=>r[2]))].sort());this.options('model',[]);this.resetSelection()}
changeMake(){const make=this.form.elements.make.value;this.byMake=(this.byYear||[]).filter(r=>r[2]===make);this.options('model',[...new Set(this.byMake.map(r=>r[3]))].sort());this.resetSelection()}
resetSelection(){this.selected=null;this.status.textContent=this.s.idle;this.dispatchEvent(new CustomEvent('chrome:vehicle-change',{bubbles:true}))}
selectModel(){const model=this.form.elements.model.value;if(!model){this.resetSelection();return}const rows=this.byMake.filter(r=>r[3]===model);const specs=new Set(rows.map(r=>JSON.stringify([r[4],r[5],r[6]])));const r=rows[0];if(!r){this.resetSelection();return}this.selected={pattern:r[4],bore:r[5],eligible:r[6]&&specs.size===1};this.status.textContent=this.selected.eligible?this.s.active+' '+r[4]+' / '+r[5]+' mm':this.s.blocked;this.dispatchEvent(new CustomEvent('chrome:vehicle-change',{bubbles:true}))}
});
function chromeWheelFilterMatch(p,v,f,vehicle,ignore){
  if(!chromeBasicFitmentMatch(v,vehicle))return false;
  const dimensions=chromeWheelDimensions(v[1]);
  const values={brand:p.brand,finish:p.finish,diameter:dimensions?String(dimensions[0]):'',width:dimensions?String(dimensions[1]):'',bolt:v[2],offset:v[3]};
  for(const key of Object.keys(values))if(key!==ignore&&f[key]&&values[key]!==f[key])return false;
  const text=(p.title+' '+p.brand+' '+p.finish+' '+v[0]).toLowerCase();
  return String(f.search||'').trim().toLowerCase().split(/\s+/).filter(Boolean).every(w=>text.includes(w));
}
if(!customElements.get('chrome-wheel-browser'))customElements.define('chrome-wheel-browser',class extends HTMLElement{
  connectedCallback(){if(this.started)return;this.started=true;document.addEventListener('chrome:vehicle-change',()=>this.filter());this.s=JSON.parse(this.querySelector('.cwb-strings').textContent);this.form=this.querySelector('form');this.grid=this.querySelector('.cwb-grid');this.count=this.querySelector('.cwb-count');this.more=this.querySelector('.cwb-more');this.sort=this.querySelector('.cwb-sort');this.money=new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'});this.limit=24;this.form.addEventListener('submit',e=>e.preventDefault());this.form.addEventListener('input',()=>{clearTimeout(this.timer);this.timer=setTimeout(()=>this.filter(),150)});this.form.addEventListener('reset',()=>setTimeout(()=>this.filter(),0));this.sort.addEventListener('change',()=>this.filter());this.more.addEventListener('click',()=>{this.limit+=24;this.render()});Promise.all(this.dataset.catalog.split(',').map(url=>fetch(url).then(r=>{if(!r.ok)throw Error();return r.json()}))).then(parts=>{this.products=parts.flatMap(d=>d.products);this.populate();this.filter()}).catch(()=>{this.count.textContent=this.s.error})}
  el(tag,text,cls){const e=document.createElement(tag);if(text!==undefined)e.textContent=text;if(cls)e.className=cls;return e}
  populate(){}
  updateOptions(f,vehicle){
    const keys=['brand','finish','diameter','width','bolt','offset'];
    const sets=Object.fromEntries(keys.map(key=>[key,new Set()]));
    this.products.forEach(p=>p.variants.forEach(v=>{
      if(!chromeBasicFitmentMatch(v,vehicle))return;
      const text=(p.title+' '+p.brand+' '+p.finish+' '+v[0]).toLowerCase();
      if(!String(f.search||'').trim().toLowerCase().split(/\s+/).filter(Boolean).every(w=>text.includes(w)))return;
      const dimensions=chromeWheelDimensions(v[1]);
      const values={brand:p.brand,finish:p.finish,diameter:dimensions?String(dimensions[0]):'',width:dimensions?String(dimensions[1]):'',bolt:v[2],offset:v[3]};
      const mismatches=keys.filter(key=>f[key]&&values[key]!==f[key]);
      if(mismatches.length>1)return;
      keys.forEach(key=>{if((!mismatches.length||mismatches[0]===key)&&values[key])sets[key].add(values[key])});
    }));
    for(const key of keys){
      const select=this.form.elements[key];const blank=select.options[0].cloneNode(true);
      const values=sets[key];if(f[key])values.add(f[key]);
      select.replaceChildren(blank);
      [...values].sort((a,b)=>String(a).localeCompare(String(b),undefined,{numeric:true})).forEach(value=>{const option=this.el('option',value);option.value=value;select.append(option)});
      select.value=f[key]||'';
    }
  }
  filter(){if(!this.products)return;this.limit=24;const f=Object.fromEntries(new FormData(this.form));const vehicle=document.querySelector('chrome-vehicle-request')?.selected;this.updateOptions(f,vehicle);this.matches=[];this.products.forEach(p=>{const vs=p.variants.filter(v=>chromeWheelFilterMatch(p,v,f,vehicle));if(vs.length)this.matches.push({p,vs,price:Math.min(...vs.map(v=>v[4]))})});const sort=this.sort.value;this.matches.sort((a,b)=>sort==='low'?a.price-b.price:sort==='high'?b.price-a.price:a.p.title.localeCompare(b.p.title));this.render()}
  quote(p,v){const u=new URL(this.dataset.quote,location.origin);u.searchParams.set('wheel',p.title);const vehicle=document.querySelector('chrome-vehicle-request form');if(vehicle)for(const key of ['year','make','model','trim']){const val=vehicle.elements[key]?.value.trim();if(val)u.searchParams.set(key,val);}if(v)u.searchParams.set('sku',v[0]);const preview=new URLSearchParams(location.search).get('preview_theme_id');if(preview)u.searchParams.set('preview_theme_id',preview);return u.pathname+u.search}
  render(){this.grid.replaceChildren();this.count.textContent=this.matches.length.toLocaleString()+' '+this.s.results;this.more.hidden=this.matches.length<=this.limit;if(!this.matches.length){this.grid.append(this.el('p',this.s.empty,'cwb-empty'));return}this.matches.slice(0,this.limit).forEach(({p,vs,price})=>{const card=this.el('article',undefined,'cwb-card');const media=this.el('div',this.s.photo,'cwb-media');if(p.image){const img=this.el('img');img.src=p.image;img.alt=p.title;img.width=500;img.height=500;img.loading='lazy';img.decoding='async';img.addEventListener('error',()=>{media.textContent=this.s.photo},{once:true});media.replaceChildren(img)}card.append(media,this.el('p',p.brand,'cwb-brand'),this.el('h2',p.title),this.el('p',p.finish,'cwb-finish'));const priceEl=this.el('p',this.s.from+' '+this.money.format(price),'cwb-price');priceEl.append(this.el('small',this.s.each));card.append(priceEl);const detail=this.el('details');detail.append(this.el('summary',this.s.options+' ('+vs.length+')'));const specs=this.el('div',undefined,'cwb-specs');detail.addEventListener('toggle',()=>{if(!detail.open||specs.childElementCount)return;vs.forEach(v=>{const row=this.el('div',undefined,'cwb-spec');row.append(this.el('strong',this.s.sku+': '+v[0]),this.el('div',v[1]+' / '+v[2]+' / '+v[3]+' mm'),this.el('div',this.s.bore+': '+(v[5]||'—')),this.el('div',this.s.load+': '+(v[6]||'—')),this.el('div',this.money.format(v[4])));specs.append(row)})});detail.append(specs);card.append(detail);const order=this.el('chrome-catalog-order');order.dataset.kind='wheels';order.dataset.title=p.title;order.dataset.brand=p.brand;order.dataset.skus=JSON.stringify(vs.map(v=>v[0]));card.append(order);this.grid.append(card)})}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chrome-hero-fade"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('chrome-hero-fade'))customElements.define('chrome-hero-fade',class extends HTMLElement{
  connectedCallback(){
    this.pool=[...this.querySelector('template').content.querySelectorAll('img')];this.bag=[];this.refreshGallery();this.slides=[...this.querySelectorAll('.chrome-hero-slide')];this.button=this.querySelector('.chrome-hero-pause');this.index=0;
    if(this.slides.length<2)return;
    this.paused=matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.button.hidden=false;this.updateButton();
    this.button.onclick=()=>{this.paused=!this.paused;this.updateButton();this.schedule()};
    this.schedule();
  }
  refreshGallery(){
    const media=this.querySelector('.banner__media');
    [...media.querySelectorAll('[data-random-slide]')].forEach(n=>n.remove());
    const chosen=[];
    while(chosen.length<Math.min(2,this.pool.length)){
      if(!this.bag.length)this.bag=this.pool.slice().sort(()=>Math.random()-.5);
      const item=this.bag.pop();if(!chosen.includes(item))chosen.push(item);
    }
    chosen.forEach(item=>{const img=item.cloneNode(true);img.dataset.randomSlide='true';media.append(img)});
    this.slides=[...this.querySelectorAll('.chrome-hero-slide')];
  }
  updateButton(){this.button.textContent=this.paused?this.button.dataset.play:this.button.dataset.pause}
  schedule(){clearInterval(this.timer);if(!this.paused)this.timer=setInterval(()=>this.advance(),30000)}
  advance(){
    if(document.hidden)return;
    const next=(this.index+1)%this.slides.length;
    if(!this.slides[next].complete||!this.slides[next].naturalWidth)return;
    this.slides[this.index].classList.remove('is-active');this.slides[this.index].setAttribute('aria-hidden','true');
    this.slides[next].classList.add('is-active');this.slides[next].setAttribute('aria-hidden','false');this.index=next;if(next===0){clearTimeout(this.refreshTimer);this.refreshTimer=setTimeout(()=>this.refreshGallery(),2100);}
  }
  disconnectedCallback(){clearInterval(this.timer);clearTimeout(this.refreshTimer)}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["chrome-offering-banners"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('chrome-offering-banners'))customElements.define('chrome-offering-banners',class extends HTMLElement{
connectedCallback(){if(matchMedia('(prefers-reduced-motion: reduce)').matches)return;this.observer=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('cob-enter');this.observer.unobserve(entry.target)}})},{threshold:0.15});this.querySelectorAll('.cob-card').forEach(card=>this.observer.observe(card))}
disconnectedCallback(){this.observer?.disconnect()}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
function selectChromeService() {
  const select = document.getElementById('ContactForm-service');
  if (!select) return;
  const params = new URLSearchParams(window.location.search);
  const service = params.get('service');
  for (const key of ['year', 'make', 'model', 'trim']) {
    const field = document.getElementById('ContactForm-' + key);
    if (field && !field.value && params.has(key)) field.value = params.get(key);
  }
  const wheelField = document.getElementById('ContactForm-brand');
  if (wheelField && !wheelField.value && params.get('wheel')) wheelField.value = params.get('wheel') + (params.get('sku') ? ' / ' + params.get('sku') : '');
  const productField = document.getElementById('ContactForm-body');
  if (productField && !productField.value.trim() && params.get('product')) productField.value = params.get('product') + (params.get('sku') ? ' / ' + params.get('sku') : '');
  for (const option of select.options) {
    if (option.dataset.service === service) { select.value = option.value; break; }
  }
}
selectChromeService();
document.addEventListener('shopify:section:load', selectChromeService);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
